import React from 'react'
import { Button } from 'react-bootstrap'
import { useNavigate } from 'react-router-dom'
import { handleSupplierCreateUpdate } from '../../../commonHandlerFunction/Purchase/Supplier/SupplierHandler'
import { handleTransferStocksCreateAndUpdate } from '../../../commonHandlerFunction/TransferStocks/TransferStocksHandler'

const TransferStocksButtons = ({
    formData,
    handleSubmit,
    setIsOverlayLoader,
    setFormData,
    viewOnly
}) => {
    const navigate = useNavigate()
    return (
        <div className="auditBtns">
            <Button
                type="button"
                className="cancelBtn"
                onClick={() => navigate("/transfer-stocks")}
            >
                Back
            </Button>

            {/* // formData[0]?.id ?
                    // <Button
                    //     type="button"
                    //     className="submitBtn"
                    //     onClick={() =>
                    //         navigate("/")
                    //     }
                    // >
                    //     Send for Approval
                    // </Button>
                    // : */}
            <>
                {
                    !viewOnly && (
                        <>
                            <Button
                                type="button"
                                className="submitBtn"
                                onClick={() =>
                                    handleTransferStocksCreateAndUpdate(
                                        formData,
                                        handleSubmit,
                                        setIsOverlayLoader,
                                        navigate,
                                        "pending"
                                    )
                                }
                            >
                                Save
                            </Button>
                            {formData[0]?.st_transfer_id &&
                                <Button
                                    type="button"
                                    className="saveBtn"
                                    onClick={() =>
                                        handleTransferStocksCreateAndUpdate(
                                            formData,
                                            handleSubmit,
                                            setIsOverlayLoader,
                                            navigate,
                                            "completed"
                                        )
                                    }
                                >
                                    Post
                                </Button>
                            }

                        </>
                    )
                }

            </>



        </div>
    )
}

export default TransferStocksButtons